import layout from 'app/store/layout';
import { handleErrors } from 'app/store/utils';

const { setLoader, createToast, setError } = layout.actions;

export { setLoader, createToast, handleErrors, setError };
